angular.module('mtic.components.modules.generalModuleMap', [
]).constant('GR78_ASSET_URL', 'assets/images/gr78/')
.constant('AGENDA_ASSETS_URL', 'assets/images/agenda/')